import { render, staticRenderFns } from "./Bottom2Nav.vue?vue&type=template&id=6e82c2ee&"
import script from "./Bottom2Nav.vue?vue&type=script&lang=js&"
export * from "./Bottom2Nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports